// extracted by mini-css-extract-plugin
export default {"statusCardContainer":"EMPStatusCard_statusCardContainer__K7l4K"};